import './style.scss';

import { createRoot } from 'react-dom';
import App from '../components/app/index';

if (document.getElementById('js-validated-voters')) {
	const root = createRoot(document.getElementById('js-validated-voters'));
	root.render(<App />);
}

let currentScene = 1;
let previousImageSrc = '';
let hasLeftInitialScene = false;
let isTransitioning = false;
let transitionTimeout = null;

const sceneImages = {
	1: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_1_desktop.png',
	2: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_2_desktop.png',
	3: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_3_desktop.png',
	4: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_4_desktop.png',
	5: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_5_desktop.png',
	6: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_6_desktop.png',
	7: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_7_desktop.png',
	8: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_8_desktop.png',
	9: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_9_desktop.png',
	10: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_10_desktop.png',
	11: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_11_desktop.png',
};

const mobileImages = {
	1: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_1_mobile.png',
	2: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_2_mobile.png',
	3: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_3_mobile.png',
	4: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_4_mobile.png',
	5: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_5_mobile.png',
	6: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_6_mobile.png',
	7: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_7_mobile.png',
	8: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_8_mobile.png',
	9: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_9_mobile.png',
	10: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_10_mobile.png',
	11: 'https://www.pewresearch.org/wp-content/uploads/sites/20/2025/06/sankey_11_mobile.png',
};

function isMobileScreen() {
	return window.innerWidth <= 768;
}

function getImageForScene(sceneNumber) {
	if (isMobileScreen()) {
		return mobileImages[sceneNumber] || sceneImages[sceneNumber];
	}
	return sceneImages[sceneNumber];
}

jQuery(document).ready(function () {
	const initialImageSrc = getImageForScene(1);
	jQuery('.validated-voters-image img').attr('src', initialImageSrc);

	var scrollPosition = jQuery(window).scrollTop();
	var windowHeight = jQuery(window).height();

	jQuery('p[class*="scene-"]').each(function () {
		var elementPosition = jQuery(this).offset().top;

		if (
			elementPosition >= scrollPosition &&
			elementPosition <= scrollPosition + windowHeight
		) {
			var re = /(?:scene\-)(?<scene>[0-9]+)/g.exec(this.classList);
			if (typeof re?.groups?.scene !== 'undefined') {
				window.dispatchEvent(
					new CustomEvent('scene', { detail: +re?.groups?.scene })
				);
				currentScene = +re?.groups?.scene;
			}
		}
	});

	jQuery('p[class*="scene-"]').visibility({
		once: false,
		observeChanges: true,
		initialCheck: true,
		checkOnRefresh: true,
		refreshOnResize: true,
		continuous: false,
		offset: -75,
		onTopVisible: function (e) {
			var re = /(?:scene\-)(?<scene>[0-9]+)/g.exec(this.classList);
			if (typeof re?.groups?.scene !== 'undefined') {
				window.dispatchEvent(
					new CustomEvent('scene', { detail: +re?.groups?.scene })
				);
				currentScene = +re?.groups?.scene;
			}
		},
	});

	window.addEventListener('scene', function (event) {
		const sceneNumber = event.detail;

		if (transitionTimeout) {
			clearTimeout(transitionTimeout);
		}

		if (isTransitioning) {
			transitionTimeout = setTimeout(() => {
				window.dispatchEvent(
					new CustomEvent('scene', { detail: sceneNumber })
				);
			}, 300);
			return;
		}

		const targetImage = getImageForScene(sceneNumber);
		if (targetImage) {
			const $container = jQuery('.validated-voters-image');
			const $image = $container.find('img');

			if (sceneNumber === 1 && !hasLeftInitialScene) {
				hasLeftInitialScene = true;
				return;
			}

			if (sceneNumber !== 1) {
				hasLeftInitialScene = true;
			}

			previousImageSrc = $image.attr('src') || getImageForScene(1);

			$container.css({
				'background-image': `url("${previousImageSrc}")`,
				'background-size': 'cover',
				'background-position': 'center',
			});

			$image.attr('src', targetImage);

			$image.css('opacity', '0');

			$image.on('load', function () {
				isTransitioning = true;

				let progress = 0;
				const fadeInterval = setInterval(function () {
					progress += 5;

					$image.css('opacity', progress / 100);
					$container.css(
						'background-image',
						`linear-gradient(rgba(255,255,255,${progress / 100}), rgba(255,255,255,${progress / 100})), url("${previousImageSrc}")`
					);

					if (progress >= 100) {
						clearInterval(fadeInterval);
						$container.css('background-image', 'none');
						isTransitioning = false;
					}
				}, 25);
			});
		}
	});

	jQuery(window).on('resize', function () {
		if (
			currentScene &&
			(sceneImages[currentScene] || mobileImages[currentScene])
		) {
			const $image = jQuery('.validated-voters-image img');
			const newImageSrc = getImageForScene(currentScene);

			if ($image.attr('src') !== newImageSrc) {
				$image.attr('src', newImageSrc);
			}
		}
	});
});
